import { DestroyRef, inject, Injectable } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NavigationEnd, Router } from "@angular/router";
import { SwUpdate } from "@angular/service-worker";

import { filter } from "rxjs";

/**
 * DEV-1020 — o service worker guarda o shell do app para ele abrir sem rede. O outro lado disso é
 * que uma versão nova só entra num recarregamento completo. Quando o SW avisa que a nova versão já
 * foi baixada, a próxima navegação recarrega a página — nunca no meio de uma tela, e sem perder o
 * que estiver na fila offline (que vive no IndexedDB, fora do ciclo de vida da página).
 */
@Injectable({ providedIn: "root" })
export class AppUpdateService {
  private readonly updates = inject(SwUpdate);
  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);
  private versionReady = false;

  public init(): void {
    if (!this.updates.isEnabled) return;

    this.updates.versionUpdates
      .pipe(
        filter((event) => event.type === "VERSION_READY"),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => (this.versionReady = true));

    // Cache corrompido pelo navegador: a única saída é recarregar do servidor.
    this.updates.unrecoverable
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.reloadPage());

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        filter(() => this.versionReady && globalThis.navigator?.onLine !== false),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => this.reloadPage());
  }

  /** Recarregamento completo da página (ponto único, substituível nos testes). */
  public reloadPage(): void {
    globalThis.location.reload();
  }
}
